import SiteNav from '@/components/organisms/SiteNav'
import { INDUSTRIES } from '@/components/organisms/IndustryPickerSection/industries'
import FooterStub from '@/components/organisms/FooterStub'
import HERO_MOBILE_ILLUSTRATION_EXT from './heroMobileIllustrations'
import IndustryHero from './components/IndustryHero'
import StatBand from './components/StatBand'
import UspSection from './components/UspSection'
import VideoBlock from './components/VideoBlock'
import ClosingCta from './components/ClosingCta'
import ReferencesBlock from './components/ReferencesBlock'
import type { IndustryPageContent } from './data/types'

interface IndustryPageProps {
    content: IndustryPageContent;
}

// Temporarily hidden on all industry pages (Sept 2026) — product videos are
// blocked on product light mode. Flip to true to restore the video block.
const SHOW_VIDEO_BLOCK = false

// Reusable industry-page template. Structure: hero → stat band → USP intro →
// 4 USP cards → video block → closing CTA → references → footer. No industry
// panel/picker on this page — removed per Charly, applies to all four
// verticals (see docs/build-log.md). Everything industry-specific lives in the
// content object (src/features/industry-page/data/*) — adding a fifth
// vertical is a new data file, not a component change.
export function IndustryPage({ content }: IndustryPageProps) {
    const industry = INDUSTRIES.find((i) => i.key === content.key) ?? INDUSTRIES[0]

    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="site-shell">
                <SiteNav />
                <IndustryHero
                    headlineLine1={content.hero.headlineLine1}
                    headlineLine2={content.hero.headlineLine2}
                    illustrationDesktop={industry.illustration.desktop}
                    illustrationMobile={HERO_MOBILE_ILLUSTRATION_EXT[content.key] ?? industry.illustration.mobile}
                />
                <StatBand header={content.statBand.header} stats={content.statBand.stats} />
                {/* Mobile-only divider between the stat band and the USP intro.
                    Not used anywhere else on the page. */}
                <hr className="mx-5 mt-8 border-t border-unimo-site-turquoise md:hidden" />
                <UspSection usps={content.usps} />
                {SHOW_VIDEO_BLOCK && <VideoBlock />}
                <ClosingCta headline={content.closingCta.headline} />
                <ReferencesBlock references={content.references} />
                <FooterStub />
            </div>

        </div>
    )
}

export default IndustryPage
